// Product gallery arrow navigation - clicks on thumbnails
if (!customElements.get('product-gallery-arrows')) {
  customElements.define('product-gallery-arrows', class ProductGalleryArrows extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const mediaGalleryId = this.dataset.mediaGallery;
      const thumbnailsId = this.dataset.thumbnails;

      const mediaGallery = document.getElementById(mediaGalleryId);
      if (!mediaGallery) return;

      const prevButton = mediaGallery.querySelector('.slider-button--prev');
      const nextButton = mediaGallery.querySelector('.slider-button--next');
      const thumbnailsContainer = document.getElementById(thumbnailsId);

      if (!prevButton || !nextButton || !thumbnailsContainer) return;

      // Remove any existing listeners by cloning and replacing
      const newPrevButton = prevButton.cloneNode(true);
      const newNextButton = nextButton.cloneNode(true);
      prevButton.parentNode.replaceChild(newPrevButton, prevButton);
      nextButton.parentNode.replaceChild(newNextButton, nextButton);

      newPrevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.navigateThumbnails(thumbnailsContainer, 'prev');
      });

      newNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.navigateThumbnails(thumbnailsContainer, 'next');
      });
    }

    navigateThumbnails(thumbnailsContainer, direction) {
      const thumbnails = Array.from(thumbnailsContainer.querySelectorAll('[data-target]'));
      const currentIndex = thumbnails.findIndex(thumb =>
        thumb.querySelector('button[aria-current="true"]')
      );

      let nextIndex;
      if (direction === 'prev') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      } else {
        nextIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      }

      const targetThumbnail = thumbnails[nextIndex];
      if (targetThumbnail) {
        targetThumbnail.querySelector('button').click();
      }
    }
  });
}
